
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Grid from '@/components/event-flow/event-flow-grid/Grid.vue';
import {
    EventFlowLocation,
    EventFlowTopic,
    EventFlowItem,
} from '@/model/event-flow/EventFlow';
import { throttle } from 'throttle-debounce';
import { createTopicFromEventFlowTopic } from '@/model/Topic';
import { createLocationFromEventFlowLocation } from '@/model/Location';

@Component({
    components: {
        Grid,
    },
})
export default class TopicGrid extends Vue {
    @Prop() readonly eventFlowTopic!: EventFlowTopic;
    @Prop() readonly eventFlowLocation!: EventFlowLocation;
    @Prop() readonly movedObject!: EventFlowItem | null;
    @Prop() readonly length!: number;
    @Prop({ type: Number, default: 48 }) readonly rowHeight!: number;

    throttleDragoverTopic = throttle(33, false, this.dragoverTopic);

    dragoverTopic(): void {
        if (
            this.movedObject &&
            (this.eventFlowTopic?.id !== this.movedObject?.topic?.id ||
                this.eventFlowLocation?.id !==
                    this.movedObject?.location?.id) &&
            !this.eventFlowTopic.items.some(
                (item) => item.id === this.movedObject?.id,
            )
        ) {
            const newEventFlowItem = { ...this.movedObject };
            newEventFlowItem.topic = createTopicFromEventFlowTopic(
                this.eventFlowTopic,
            );
            newEventFlowItem.location = createLocationFromEventFlowLocation(
                this.eventFlowLocation,
            );
            this.itemChangedLocal(newEventFlowItem);
        }
    }

    @Emit()
    itemChangedLocal(item: EventFlowItem): EventFlowItem {
        return item;
    }
}
